<template>
  <div class="container">
    <h1 class="uk-text-center title">
      Informativo de Cadena de Frío
    </h1>
    <div
      class="uk-position-relative uk-visible-toggle uk-light slide"
      tabindex="-1"
      uk-slideshow
    >
      <ul class="uk-slideshow-items">
        <li>
          <img
            src="../assets/img/s1.png"
            alt=""
            uk-cover
          >
        </li>
        <li>
          <img
            src="../assets/img/s2.png"
            alt=""
            uk-cover
          >
        </li>

        <li>
          <img
            src="../assets/img/s3.png"
            alt=""
            uk-cover
          >
        </li>

        <li>
          <img
            src="../assets/img/s4.png"
            alt=""
            uk-cover
          >
        </li>

        <li>
          <img
            src="../assets/img/s5.png"
            alt=""
            uk-cover
          >
        </li>

        <li>
          <img
            src="../assets/img/s6.png"
            alt=""
            uk-cover
          >
        </li>

        <li>
          <img
            src="../assets/img/s7.png"
            alt=""
            uk-cover
          >
        </li>

        <li>
          <img
            src="../assets/img/s8.png"
            alt=""
            uk-cover
          >
        </li>

        <li>
          <img
            src="../assets/img/s9.png"
            alt=""
            uk-cover
          >
        </li>

        <li>
          <img
            src="../assets/img/s10.png"
            alt=""
            uk-cover
          >
        </li>
      </ul>

      <a
        class="uk-position-center-left uk-position-small uk-hidden-hover arrow"
        href="#"
        uk-slidenav-previous
        uk-slideshow-item="previous"
      />
      <a
        class="uk-position-center-right uk-position-small uk-hidden-hover arrow"
        href="#"
        uk-slidenav-next
        uk-slideshow-item="next"
      />
    </div>
    <br>
    <div class="uk-flex uk-flex-center">
      <button
        class="uk-button"
        @click="pushPage('DragAndDropTimeLine')"
      >
        Comienza Ahora Cadena de Frío
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    pushPage (name) {
      this.$store.dispatch('resetCosts')
      this.$router.push({ name })
      this.$windowPlugin.scrollToTop()
    }
  }
}
</script>

<style scoped>
.container{
    min-height: 656px;
}
.slide{
    width: 90%;
    height: 100%;
    margin: 0px auto;
    border: 2px solid rgba(00, 00, 00, 0.5);
    border-radius: 5px;
}
ul{
  width: 100%;
  margin: 0px auto
}
li{
  height: 100%;
  width: 100%;
}
img{
  width: 90% !important;
  height: 92% !important
}
.title{
  font-size: 18px;
  font-weight: bold
}
.arrow{
  background: rgba(00, 00, 00, 0.5);
  color: #fff;
}
</style>
